import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    nickname,
    gender = '',
    province = '',
    city = '',
    county = '',
    address = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.updateCurrentInfo, {
        nickname,
        gender,
        province,
        city,
        county,
        address,
    }, options);
    if (error) return { error, status };
    return content || {};
};
